<div *ngIf="visibleCount > 0; else noOptions" class="tw-flex-initial tw-justify-self-end tw-self-center tw-flex tw-items-center tw-gap-2">
  <ng-content select=".approval-status"></ng-content>
  <app-approval-menu
    class="tw-justify-self-end tw-self-center"
    [approvalMenuItems]="approvalMenuItems"
  ></app-approval-menu>
</div>
<ng-template #noOptions>
  <ng-content></ng-content>
</ng-template>
